@use 'vars';

.askiq {
  &__pop-up {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background: vars.$white;
    border-radius: vars.$border-radius-small;
    border: vars.$border-size-thin solid vars.$ai-primary;
    z-index: vars.$z-index-above-modal;
    overflow: hidden;
    opacity: 1;
    transition: opacity 0.5s ease-in-out;

    &--action-menu-small {
      //This is required to avoid jank when button reenters once action sheet is closed
      min-height: fit-content !important;
      max-width: fit-content !important;
    }

    &--action-sheet-open {
      opacity: 0 !important;
      border: none !important;
    }
  }

  &__pop-up-button {
    color: vars.$ai-primary;
    background: none;
    border: none;
    padding: vars.$padding-xsmall vars.$padding-medium;
    height: 100%;
    width: 100%;
    cursor: pointer;
  }
}
